import React, {useEffect, useMemo, useState} from "react";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";

//used for Nested Test Questions
const GroupInstructions = ({ questionData, getMaxMark, ...rest }) => {

    const [maxMark, setMaxMark] = useState(null);
    useEffect(()=>{
        if(maxMark !== null){
            getMaxMark?.(maxMark);
        }
    },[maxMark]);

    const htmlStr = useMemo(()=>{
        let currentMaxMarkCount = 0;
        let htmlString = '';

        if (questionData.groupInstructions) {
            htmlString += `<div>${questionData.groupInstructions}</div>`;
        }

        const childQuestions = questionData.childQuestions || [];
        childQuestions.forEach((childQuestion, index) => {

            if (childQuestion.questionType === 'GROUP_QUESTION') {
                const subChildQuestions = childQuestion.childQuestions || [];
                let subQuestionsHtml = '';

                subChildQuestions.forEach((subChildQuestion, subIndex) => {
                    currentMaxMarkCount += subChildQuestion.maxMark || 0;

                    subQuestionsHtml += `<div class="nestedQuestion">
                        <div class="subQuestionLabel">${subChildQuestion.questionNumberPart}.</div>
                        <div>${subChildQuestion.instructions}</div>
                    </div>`;
                });

                htmlString += `<div class="nestedQuestion group-container">
                    <div class="subQuestionLabel">${childQuestion.questionNumberPart}.</div>
                    ${childQuestion.groupInstructions ? `<div>${childQuestion.groupInstructions}</div>` : ''}
                    <di>
                        ${subQuestionsHtml}
                    </di>
                </div>`;

            } else {
                currentMaxMarkCount += childQuestion.maxMark || 0;
                htmlString += `<div class="nestedQuestion">
                    <div class="subQuestionLabel">${childQuestion.questionNumberPart}.</div>
                    <div>
                        ${childQuestion.instructions}
                    </div>
                </div>`;
            }
        });
        setMaxMark(currentMaxMarkCount);
        return htmlString;
    },[questionData])

    return (
        <MathJaxHTMLContent html={htmlStr} {...rest} />
    );
}
export default GroupInstructions;